<template>
  <div>
    <template v-if="showSignup">
      <b-button
        @click="personaliseSignup"
        class="js-open-signup-popup w-full m:w-72"
        :data-login-path="loginPath"
        :data-signup-path="signupPath"
      >
        {{ $t("createAccount") }}
      </b-button>
    </template>
    <template v-if="showLogin">
      <p class="mt-4 mb-0 text-center m:text-left">
        {{ $t("alreadyHaveAnAccount") }}
        <a
          @click="personaliseLogin"
          :href="loginPath"
          class="js-open-login-popup"
          :data-login-path="loginPath"
          :data-signup-path="signupPath"
        >
          {{ $t("login") }}
        </a>
      </p>
    </template>
    <template v-if="!showSignup && !showLogin">
      <form method="post" :action="joinPath">
        <input type="hidden" name="authenticity_token" :value="authenticityToken" />
        <b-button :disabled="disabled" :class="{ 'm:w-72': !fullWidth }" class="w-full" type="submit">
          {{ $t("accept") }}
        </b-button>
      </form>

      <p v-if="showLogoutLink" class="mt-4 mb-0 text-center m:text-left">
        <a :href="logoutPath">{{ $t("notYourAccount") }}</a>
      </p>
    </template>
  </div>
</template>

<script>
import BButton from "@/component-library/b-button"
import globals from "@/utils/globals"
import { mapGetters } from "vuex"

export default {
  name: "ButtonsSection",
  components: {
    BButton
  },
  props: {
    showLogin: {
      default: false,
      type: Boolean
    },
    showSignup: {
      default: false,
      type: Boolean
    },
    showLogoutLink: {
      default: false,
      type: Boolean
    },
    inviteCode: {
      required: true,
      type: String
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["authenticityToken"]),
    joinPath() {
      return `/${this.$i18n.locale}/nc/join/${this.inviteCode}`
    },
    joinPathAfterLoginOrSignup() {
      return `/${this.$i18n.locale}/nc/join/${this.inviteCode}?fromLoginSignup=true`
    },
    signupPath() {
      return `${globals.routes.signup}?last_page_before_login=${encodeURIComponent(this.joinPathAfterLoginOrSignup)}`
    },
    loginPath() {
      return `${globals.routes.login}?last_page_before_login=${encodeURIComponent(this.joinPathAfterLoginOrSignup)}`
    },
    logoutPath() {
      return `${globals.routes.logout}?last_page_before_login=${encodeURIComponent(this.joinPath)}`
    }
  },
  i18n: {
    messages: {
      en: {
        createAccount: "Create personal account",
        alreadyHaveAnAccount: "Already have an account?",
        login: "Log in",
        notYourAccount: "This is not your account?",
        accept: "Accept Invitation"
      },
      de: {
        createAccount: "Kostenloses Konto aktivieren",
        alreadyHaveAnAccount: "Schon registriert? Dann einfach",
        login: "einloggen",
        notYourAccount: "Nicht dein Account?",
        accept: "Einladung annehmen"
      }
    }
  }
}
</script>
